import React from 'react';
import { Lottie } from '@crello/react-lottie';

const InvisibleToInvincibleCard = props => {
  const { headerText, animationData, animationWidth, animationHeight, text } = props;

  return (
    <div className="max-w-[350px] flex flex-col gap-[20px]">
      <div className="flex flex-row  gap-[23px]">
        <Lottie
          width={animationWidth}
          height={animationHeight}
          config={{
            animationData: animationData,
            loop: true,
            autoPlay: true,
          }}
          playingState="playing"
        />
        <h3 className="text-[24px] font-[600] leading-[29px]">{headerText}</h3>
      </div>

      <p className="text-[16px] leading-[20px] font-[400]">{text}</p>
    </div>
  );
};

export default InvisibleToInvincibleCard;
